import React, { useState } from "react";
import { handleKeyDown } from "../../utils/utils";

interface TooltipProps {
  text: string;
  position?: "top" | "bottom" | "left" | "right";
  children: React.ReactNode;
  textColor?: string;
  backgroundColor?: string;
  zIndex?: number;
  imgSrc?: string
  maxWidth?: string
}

const MgpTooltip: React.FC<TooltipProps> = ({ 
    text, 
    position = "top", 
    children, 
    backgroundColor, 
    textColor, 
    zIndex, 
    imgSrc,
    maxWidth = '500px' }) => {
  const [show, setShow] = useState(false);

  const handleMouseEnter = () => {
    setShow(true);
  };

  const handleMouseLeave = () => {
    setShow(false);
  };

  const getTooltipClassName = () => {
    return `tooltip ${position}`;
  };
  const getArrowClassName = () => {
    return `${position}-arrow`;
  };

  const tooltipStyle = backgroundColor ? {
    backgroundColor: backgroundColor ,
    color: textColor
  } : {};

  return (
    <div 
      className="tooltip-container" 
      onMouseEnter={handleMouseEnter} 
      onMouseLeave={handleMouseLeave} 
      style={zIndex ? {zIndex: zIndex}: {}} 
      role='button' tabIndex={0} 
      onKeyDown={(e) => handleKeyDown(e)}>
      <span className="tooltip-anchor" >{children}</span>
      {show && (
        <div className={getTooltipClassName()} style={tooltipStyle}>
          <div className={getArrowClassName()}></div>
          <div dangerouslySetInnerHTML={{ __html: text.replace(/\n/g, "<br/>") }} style={{maxWidth: maxWidth, whiteSpace: 'pre-line'}}></div>
          {
            imgSrc && <img src={imgSrc} alt='' className="tooltip-image mt-sm"/>
          }
          
        </div>
      )}
    </div>
  );
};

export default MgpTooltip;

